import { render, staticRenderFns } from "./NotesView.vue?vue&type=template&id=031ffca0&scoped=true"
import script from "./NotesView.vue?vue&type=script&lang=js"
export * from "./NotesView.vue?vue&type=script&lang=js"
import style0 from "./NotesView.vue?vue&type=style&index=0&id=031ffca0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ffca0",
  null
  
)

export default component.exports